import { useBoardService } from 'src/features/boards';
import { v4 as uuid } from 'uuid';

import { findColumnIndexById } from '../../utils/findColumnIndexById';
import { ColumnSlice, CreateColumnSlice } from '../types';
const { addColumn, deleteColumn, updateColumn, updateColumnOrder } = useBoardService();
export const createColumnSlice: CreateColumnSlice = (set, get): ColumnSlice => ({
  columns: [],
  setColumns: (value) =>
    set((state) => {
      state.columns = value;
    }),
  removeItemsFromBoard: (itemIds) => {
    set((state) => {
      const columns = JSON.parse(JSON.stringify(state.columns));
      columns.forEach((column) => {
        column.items = column.items.filter((item) => !itemIds.includes(item.id));
      });
      state.columns = columns;
    });
  },

  setOnUpdateOrderColumns: (func) =>
    set((state) => {
      state.onUpdateOrderColumns = func;
    }),

  onChangeColumnName: async ({ id, name }) => {
    set((state) => {
      const foundIndex = findColumnIndexById(state.columns, id);
      if (foundIndex > -1) {
        if (name.length === 0) name = 'Untitled';
        state.columns[foundIndex].name = name;
      }
    });
    const response = await updateColumn({ colKey: 'name', colProperties: { name }, id });
    if (response) {
      get().fetchBoard();
    }
  },

  onChangeColumnColor: async ({ color, id }) => {
    let foundColIndex = -1;
    set((state) => {
      foundColIndex = findColumnIndexById(state.columns, id);
      if (foundColIndex > -1) {
        state.columns[foundColIndex].color = color;
      }
    });
    const board = await updateColumn({ colKey: 'color', colProperties: { color }, id });
    if (board) {
      get().fetchBoard();
    }
  },
  onAddNewColumn: async () => {
    set((state) => {
      const id = uuid();
      state.columns.push({
        name: 'New Column',
        items: [],
        id: id,
        color: '',
      });
    });
    const board = await addColumn({ boardId: get().boardId, color: '#DFF8E3', name: 'New column' });
    if (board) {
      get().fetchBoard();
      return true;
    }
  },
  onDeleteColumn: async ({ columnId }) => {
    let foundColIndex = -1;
    set((state) => {
      foundColIndex = findColumnIndexById(state.columns, columnId);
      if (foundColIndex > -1) {
        state.columns = state.columns.filter((obj) => obj.id !== columnId);
      }
    });

    if (foundColIndex > -1) {
      const board = await deleteColumn({ colId: columnId });
      if (board) {
        get().fetchBoard();
      }
    }
  },
  onChangeColumnOrder: async ({ columnIds }) => {
    set((state) => {
      const sortedColumns = state.columns.sort((a, b) => {
        return columnIds.indexOf(a.id) - columnIds.indexOf(b.id);
      });
      state.columns = sortedColumns;
    });
    const board = await updateColumnOrder({ boardId: get().boardId, columnIds });
    if (board) {
      get().fetchBoard();
    }
  },
});
